// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1swEL","vLegacy":"SelectSecondary_vLegacy__3-n88","error":"SelectSecondary_error__3RPmX","disabled":"SelectSecondary_disabled__2LoUx"};